export default "__VITE_ASSET__D$SR6dyN__"